import store from "@redux/store";
import { CLIENTS_OF_RM_ERROR, CLIENTS_OF_RM_HIDE_ERROR, CLIENTS_OF_RM_START_LOADER, CLIENTS_OF_RM_STOP_LOADER, GET_CLIENTS_OF_RM, UPDATE_CURRENT_SELECTED_TRANSACTIONS_TAB, } from "../interface/IMutualFundTransactionCommon";
var OrderbookMutualFundCommonTransactions = /** @class */ (function () {
    function OrderbookMutualFundCommonTransactions() {
        this.dispatch = store.dispatch;
    }
    OrderbookMutualFundCommonTransactions.prototype.updateCurrentActiveTransactionsTab = function (data) {
        this.dispatch({
            type: UPDATE_CURRENT_SELECTED_TRANSACTIONS_TAB,
            payload: { currentSelectedTransactionTab: data },
        });
    };
    OrderbookMutualFundCommonTransactions.prototype.startGetAllClientOfRMLoader = function () {
        this.dispatch({
            type: CLIENTS_OF_RM_START_LOADER,
        });
    };
    OrderbookMutualFundCommonTransactions.prototype.stopGetAllClientOfRMLoader = function () {
        this.dispatch({
            type: CLIENTS_OF_RM_STOP_LOADER,
        });
    };
    OrderbookMutualFundCommonTransactions.prototype.getAllClientsOfRM = function (data) {
        this.dispatch({
            type: GET_CLIENTS_OF_RM,
            payload: { clientsData: data },
        });
    };
    OrderbookMutualFundCommonTransactions.prototype.setErrorForAllClientsOfRM = function (payload, errorType) {
        this.dispatch({
            type: CLIENTS_OF_RM_ERROR,
            payload: { errorData: payload },
        });
    };
    OrderbookMutualFundCommonTransactions.prototype.hideErrorForAllClientsOfRM = function (errorType) {
        this.dispatch({
            type: CLIENTS_OF_RM_HIDE_ERROR,
        });
    };
    return OrderbookMutualFundCommonTransactions;
}());
export default OrderbookMutualFundCommonTransactions;
